export default __webpack_public_path__ + "static/media/minusIcon.354ce1a8.svg";